import * as React from 'react';
import { Grid } from '@mui/material';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { Http, LinkedIn } from '@mui/icons-material';
import { useGlobal } from '../../utils/GlobalContext';
import { useEffect, useState } from 'react';
import { UserProfile, newUserProfile } from '../../data/userProfile';
import { useNavigate } from 'react-router-dom';
import { UserPresentation } from '../../data/userProfile';
import { SessionSpeaker } from '../../data/SessionData';
import SpeakerInfoModal from '../common/SpeakerInfoModal';
export function SpeakerComponent(){
    const { state } = useGlobal();
    const navigate = useNavigate();
    if (state.UserProfile.IsExistingUser === false && state.UserProfile.Id!=="") {
      navigate("/account");
  }
    const style = {
        position: 'absolute' as 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 400,
        bgcolor: 'background.paper',
        border: '2px solid #000',
        boxShadow: 24,
        p: 4,
    };
    const [open, setOpen] = useState(false);
    const [speakers, setSpeakers] = useState<UserProfile[]>();
    useEffect(()=>{
        if(state.SelectedEvent!==undefined && state.Profiles!==undefined && 
          state.SelectedEvent.Sessions.length!=0 && 
          speakers==undefined && state.Profiles.length!=0){
            let filteredspeakers: UserProfile[]=[];
            for(let p=0; p< state.Profiles.length; p++){
              for (let i = 0; i < state.SelectedEvent.Sessions.length; i++) {                
                if(state.Profiles[p].PresentationSessions.find((element) => 
                element.EventId === state.SelectedEvent.Sessions[i].EventId && element.SessionId === state.SelectedEvent.Sessions[i].Id
                )!==undefined)
                  {
                      filteredspeakers.push(state.Profiles[p]);
                      break;
                  }
              }
            }
            setSpeakers(filteredspeakers);
        }
    });

    // Speaker Modal Hookup
    const [speakerInfoOpen, setSpeakerInfoOpen] = useState(false);
    const [selectedSpeaker, setSelectedSpeaker] = useState<UserProfile>(newUserProfile());
    const handleSpeakerModalOpen = (speaker: UserProfile) => {
        setSelectedSpeaker(speaker);
        setSpeakerInfoOpen(true);
    };
    const handleSpeakerModalClose = () => {
        setSpeakerInfoOpen(false);
    };
return (
    <>
        <h2 className="blueText">{state.SelectedEvent?.Name}  Speakers</h2>
        <br/>
        <br/>
        <Grid container spacing={2}>
        {
          
          speakers?.sort((a,b)=>{return (a.FirstName+" "+a.LastName).toUpperCase()<(b.FirstName+" "+b.LastName).toUpperCase()?-1:1;}).map((profile) => (
            <>
                <Grid item xs={6} md={2} onClick={()=>handleSpeakerModalOpen(profile)}>
                    <center>
                        <img className='StaffImage' alt='{profile?.FirstName} {profile?.LastName}' src={(profile?.PictureLink)??"https://creazilla-store.fra1.digitaloceanspaces.com/icons/3220761/user-circle-icon-md.png"}/>
                        <div>{profile?.FirstName} {profile?.LastName}</div>
                        <LinkedIn /> &nbsp; &nbsp; <Http />
                    </center>
                </Grid>
            </>
          ))
        }
        </Grid>
        <SpeakerInfoModal show={speakerInfoOpen} onClose={handleSpeakerModalClose} speaker={selectedSpeaker}/>
    </>
);
};
